import { COMPETITION_PAGE_BG } from '@/components/layout/competitionBranding';
import { PublicFooter } from '@/components/layout/Footer';
import { PublicHeader } from '@/components/layout/Header';
import { OrganizerLogoBar } from '@/components/layout/OrganizerLogoBar';
import { useCompetitionSessionRestore } from '@/hooks/useCompetitionSession';

export const PublicHomePage = () => {
  useCompetitionSessionRestore({
    redirectOnSuccess: (data) => (data.inProgress ? '/turniej' : '/poczekalnia'),
  });

  return (
    <div className="font-rounded flex flex-col">
      <PublicHeader />

      <section style={{ background: COMPETITION_PAGE_BG }}>
        <OrganizerLogoBar />
      </section>

      <section className="relative w-full overflow-hidden shadow-[0_-1px_0_0_rgba(76,197,240,0.15)]">
        <picture className="block w-full">
          <source media="(max-width: 640px)" srcSet="/images/hero_phone_02.jpg" />
          <source media="(max-width: 1024px)" srcSet="/images/hero_tab.jpg" />
          <img
            src="/images/hero02.jpg"
            alt="Turniej Przetwórstwo Mleczarskie"
            className="block h-auto w-full"
          />
        </picture>
      </section>

      <PublicFooter />
    </div>
  );
};
